import LocalizedStrings from 'react-localization/lib/LocalizedStrings';

export const strings = new LocalizedStrings({
  en: {
    generalDescription:
      'We bring you short documentary stories from the Nordic countries that celebrates the positive, curiosity and learning. Discover fact based stories and get new perspectives from science, companies, people and places.',
    ogTitle: 'The storytelling channel – Factuals.com',
    ogDescription:
      'We bring you short documentary stories from the Nordic countries that celebrates the positive, curiosity and learning. Discover fact based stories and get new perspectives from science, companies, people and places.',
    generalTitle: 'Factuals',
    twitterDescription:
      'We bring you short documentary stories from the Nordic countries that celebrates the positive, curiosity and learning. Discover fact based stories and get new perspectives from science, companies, people and places.',
    twitterTitle: 'The storytelling channel – Factuals.com',
    pageNotFound: 'Page not found!',
    homeHeroTitle: 'Title of the home page',
    footerTitle: 'FACTUALS',
    headerTitle: 'FACTUALS',
    episodes: 'Episodes',
    episodesCount: 'EPISODES',
    episodesInThisSeries: 'EPISODES IN THIS SERIES',
    moreEpisodesInThisSeries: 'MORE EPISODES IN THIS SERIES',
    episodesInThisCategory: 'EPISODES IN THIS CATEGORY',
    allEpisodes: 'All episodes',
    allEpisodesPage: 'Episodes-Page',
    allSeries: 'All series',
    allSeriesPage: 'Series-Page',
    episode: 'Episode',
    series: 'Series',
    seriesAdminTitle: 'Series admin',
    episodesAdminTitle: 'Episodes admin',
    categories: 'Categories',
    category: 'Category',
    categoryAdminTitle: 'Category admin',
    collaborate: 'Collaborate',
    aboutUs: 'About us',
    partners: 'Partners',
    sponsor: 'Sponsor',
    noSponsor: 'No sponsor',
    sponsors: 'Sponsors',
    sponsorsAdminTitle: 'Sponsors admin',
    homePageAdminTitle: 'Home page admin',
    allEpisodesAdminTitle: 'All Episodes page admin',
    allSeriesAdminTitle: 'All Series page admin',
    AD: 'AD',
    whoWeAre: 'Who we are',
    getInContact: 'Get in contact',
    contact: 'Contact',
    follow: 'Follow',
    required: 'Required',
    title: 'Title',
    color: 'Color',
    description: 'Description',
    slug: 'Slug',
    featuredEpisode: 'In slider on front page',
    featuredSeries1: 'In slider on front page',
    featuredSeries2: 'In grid on front page',
    status: 'Status',
    loading: 'Loading...',
    homepage: 'Homepage',
    user: 'User',
    users: 'Users',
    usersAdminTitle: 'User admin',
    unchanged: 'Unchanged',
    username: 'Username',
    password: 'Password',
    role: 'Role',
    active: 'Active',
    ctaUrl: 'CTA URL',
    statusPrivate: 'Private',
    statusPublished: 'Published',
    delete: 'Delete',
    addEpisode: 'Add episode',
    changePicture: 'Change picture',
    selectPicture: 'Select picture',
    clearCrop: 'Reset picture',
    removeImage: 'Remove picture',
    heroTitle: 'Hero title',
    heroDescription: 'Hero description',
    heroImage: 'Hero image',
    heroCtaTitle: 'Hero CTA-title',
    heroCtaUrl: 'Hero CTA-url',
    thumbnailImage: 'Thumbnail-image',
    image: 'Image',
    link: 'Link',
    order: 'Order',
    activate: 'Activate',
    deactivate: 'Deactivate',
    uspTitle: 'USP-title',
    uspDescription: 'USP-description',
    playVideo: 'PLAY VIDEO',
    playBeginning: 'Play from the beginning',
    uspCtaTitle: 'USP CTA-title',
    uspCtaUrl: 'USP CTA-url',
    graphicArrowsLabel: 'LIKE THIS',
    home: 'Home',
    aboutTheSeries: 'About the series',
    aboutTheEpisode: 'About the episode',
    readMore: 'Read More',
    gotIt: 'GOT IT',
    poweredBy: 'powered by',
    cookiePolicy: 'Cookie Policy.',
    cookieText:
      'We use cookies to improve your experience and deliver personalised content. By using Factuals, you agree to our',
    allSeriesHeroTitle: 'All series template content',
    allSeriesHeroLeadText:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    allEpisodesHeroTitle: 'All episodes template content',
    allEpisodesHeroLeadText:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    somethingWentWrong: 'Bad luck, something went wrong. Please try again.',
    categoryHeroTitle: 'Category Specific template',
    categoryHeroLeadText:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    tryAgain: 'Try again',
    seriesIn: 'Series in ',
    episodesIn: 'Episodes in ',
    factualsRights: '© Factuals. All rights reserved.',
    signIn: 'Sign in',
    maxFileSize: 'Max file size is 1MB',
    aboutUsHeroTitle: 'Hello!',
    aboutUsHeroDescription:
      'We founded Factuals in 2020 as a documentary storytelling channel for today’s digital world. Here we share stories, series, and new formats from the nordic countries.',
    aboutUsPhoneticsWord: 'Factuals',
    aboutUsPhonetics: '[fak-tchoo-uh ls]',
    aboutUsPhoneticsDescription:
      'Inspiring, untold and amazing stories based on facts and real events.',
    theTeam: 'THE TEAM',
    theTeamLeadText:
      'Factuals is constantly developing, with a growing team and network of experienced international journalists, producers, designers and digital media experts.',
    advisoryBoard: 'ADVISORY BOARD',
    editorialBoard: 'EDITORIAL BOARD',
    ceoPerson: 'Jan Axelsson',
    ceo: 'CEO / Founder / Publisher',
    ceoMail: 'jan@factuals.com',
    ceoMobile: '+46 706851444',
    headOfOperationsPerson: 'Jennie Tinderfjäll',
    headOfOperations: 'Head of operations / Founder',
    headOfOperationsMail: 'jennie@factuals.com',
    headOfProductionPerson: 'Arvid Sundqvist',
    headOfProduction: 'Head of production / Founder',
    headOfProductionMail: 'arvid@factuals.com',
    mediaStrategist: 'Strategy',
    mediaStrategistPerson: 'Mattias Fyrenius',
    bureauCommunication: 'Bureau communication',
    bureauCommunicationPerson: 'Sarita Nath',
    legalAdvicePerson: 'Oskar Malmquist',
    legalAdvice: 'Strategy and Legal',
    professor: 'Professor history of science, Royal Swedish Academy of Science',
    professorPerson: 'Christer Nordlund',
    headOfPopularScience: 'Head of popular science center Curiosum',
    headOfPopularSciencePerson: 'Madelen Bodin',
    alien: "Don't be an Alien",
    whatsYourStory: "What's your story?",
    emailIdea: 'ideas@factuals.com',
    workWithUs: 'Work with us',
    workWithUsLeadText:
      'We are always looking out for great producers and production companies',
    emailWork: 'work@factuals.com',
    collaborateWithUs: 'Collaborate with us',
    findOutMore: 'FIND OUT MORE',
    collaborateHeroTitle: 'Collaborate',
    collaborateHeroDescription:
      'Factuals is a storytelling channel that collaborates with companies, organizations, and places. We are financed through sponsorships.',
    collaborateUspTitle: 'Design a great story',
    collaborateUspDescription:
      'The art of storytelling is as old as people are, and a good story has the potential to change our view and inspire. But the way we tell and share stories has changed. By learning from data analytics we now have a much better understanding of how and where to find the right people and how to create great digital stories with real measurable impact.',
    watchTheSeries: 'WATCH THE SERIES',
    collaboratorsTitle: 'Local to Global impact',
    collaboratorsLeadText:
      'Our producers and storytellers are highly experienced and collaborate with a broad range of international media productions. We know how to take a story from local to global impact.',
    collaborateSectionTitle: 'Collaborate',
    collaborateSectionLeadText: 'For business, organisations and partners',
    emailCollaborate: 'collaborate@factuals.com',
    phoneNumberCollaborateSection: '+46 70 685 14 44',
    collaborateFloatContact: 'Contact',
    collaborateFloatUs: 'Us!',
    producedBy: 'Site produced by',
    privacyAndCookies: 'Privacy & Cookies',
  },
});

strings.setLanguage('en'); // use setLanguage to change to another language
